import { FETCH_NEIGHBORS_SUCCESS, FETCH_NEIGHBORS } from '../actions'

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_NEIGHBORS_SUCCESS:
      return {
        result: action.payload,
        loading: false
      }
    case FETCH_NEIGHBORS:
      return {
        loading: true
      }
  }
  return state
}
